import { createFileRoute } from "@tanstack/react-router";
import GranolaPage from "@/components/Granola";

export const Route = createFileRoute("/_authenticated/granola/")({
  component: GranolaPage,
  staticData: { page: "sales" },
});
